import { ApiService } from "./api.service";

export default class PrintCheckService extends ApiService {
  namespace = "print-check";
  name = "Type";
  favicon = "Printer";
  window = 290;
  Width = 1100;
  realm = 2;
  DOMAIN = -70;
  preClosed = true;
  action = "actionApply";
  type = "type";
  singular = this.terminology.printCheck.singular;
  plural = this.terminology.printCheck.plural;
  vowel = this.terminology.printCheck.vowel;
  constructor() {
    super("print/check");
  }
}
